// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"01cc0c03","526":"78814f22","787":"5c286b14"}[chunkId] + ".chunk.js";
};